export const PhoneNumbersRegions = {
  lang_fi: {
    callNumber1: {
      description: '',
      visual: '10 19 19 19',
      link: '+35810191919',
    }
  },
  lang_se: {
    callNumber1: {
      description: '',
      visual: '0771- 655 655',
      link: '+46771655655',
    }
  },
  lang_no: {
    callNumber1: {
      description: '',
      visual: '21 49 24 00',
      link: '+4721492400',
    }
  },
  lang_dk: {
    callNumber1: {
      description: '',
      visual: '70 12 12 12',
      link: '+4570121212',
    }
  },
  lang_en: {
    callNumber1: {
      description: '',
      visual: '10 19 19 19',
      link: '+35810191919',
    }
  }
}